import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/admin.jpg'


const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<form class=\"search-box\"><div class=\"input-group\"><input type=\"text\" class=\"form-control shadow-none rounded-0 border-0\" placeholder=\"Buscar opción de menu\"><button class=\"default-btn position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20\" type=\"button\"> Buscar <i class=\"flaticon-search-interface-symbol position-relative ms-5 top-1\"></i></button></div></form>", 1)
const _hoisted_7 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_8 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_9 = { class: "dropdown notification-dropdown" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-bell-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot-badge position-absolute fw-bold rounded-circle text-white bg-primary d-inline-block" }, " 3 ")
], -1)
const _hoisted_11 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "title d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-black fw-bold" }, [
    /*#__PURE__*/_createTextVNode("Notificaciones "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted" })
  ])
], -1)
const _hoisted_13 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_14 = { class: "text-muted position-relative" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-chat-centered-dots" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode("You have requested to "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "withdrawal")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10" }, null, -1)
const _hoisted_18 = { class: "text-muted position-relative" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-user-plus" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "A new user"),
  /*#__PURE__*/_createTextVNode(" added in Adlash ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10" }, null, -1)
const _hoisted_22 = { class: "text-muted position-relative" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon rounded-circle position-absolute text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-chat-centered-dots" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis" }, [
  /*#__PURE__*/_createTextVNode(" You have requested to "),
  /*#__PURE__*/_createElementVNode("strong", { class: "fw-semibold" }, "withdrawal")
], -1)
const _hoisted_25 = { class: "text-center dropdown-footer" }
const _hoisted_26 = { class: "dropdown profile-dropdown" }
const _hoisted_27 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rounded",
  width: "44",
  height: "44",
  alt: "admin"
}, null, -1)
const _hoisted_29 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_30 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_31 = { class: "text-body-emphasis fw-semibold fs-13" }
const _hoisted_32 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_33 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_34 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-2" }, null, -1)
const _hoisted_36 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1)
const _hoisted_38 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
    'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
    { sticky: _ctx.isSticky },
  ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_5),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createTextVNode(" 2 hrs ago "),
                  _createVNode(_component_router_link, {
                    to: "/notifications",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  }),
                  _hoisted_17
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createTextVNode(" 3 hrs ago "),
                  _createVNode(_component_router_link, {
                    to: "/notifications",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  }),
                  _hoisted_21
                ]),
                _createElementVNode("li", _hoisted_22, [
                  _hoisted_23,
                  _hoisted_24,
                  _createTextVNode(" 1 day ago "),
                  _createVNode(_component_router_link, {
                    to: "/notifications",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_router_link, {
                  to: "/notifications",
                  class: "link-btn text-decoration-none text-primary position-relative d-inline-block transition fw-medium fw-medium"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ver todo ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.curUserPayload?.UserName || " "), 1),
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.curUserPayload?.Rol || ""), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("ul", _hoisted_33, [
                _createElementVNode("li", _hoisted_34, [
                  _hoisted_35,
                  _createTextVNode(" Mi Perfil "),
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_36, [
                  _hoisted_37,
                  _createTextVNode(" Configuración "),
                  _createVNode(_component_router_link, {
                    to: "/profile-settings",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_38, [
                  _hoisted_39,
                  _createTextVNode(" Soporte "),
                  _createVNode(_component_router_link, {
                    to: "/support-desk-card",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", {
                  class: "text-body-secondary fw-semibold transition position-relative",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                }, [
                  _hoisted_40,
                  _createTextVNode(" Cerrar Sesión ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}